/* Collaviva – Bewegung für die cv-Sektionen. Ohne Abhängigkeiten. */
(function () {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (window.clReveal) window.clReveal();

  /* Zahlen hochzählen */
  const lang = document.documentElement.lang || 'de';
  const fmt = (n, mode) => mode === 'raw' ? String(n) : new Intl.NumberFormat(lang).format(Math.round(n));
  /* Texte aus den Sprachdateien (cl-head) und Preise im Format der Marktwährung („€1.234,56“, „1.234,56 lei“) */
  const tr = (s, a) => ((window.clT && window.clT[s]) || s).replace('[a]', a === undefined ? '' : a);
  const money = (c) => {
    const smp = window.clMoney || '€1.234,56', m = smp.match(/1(\D?)234(\D)56/);
    const [w, f] = (Math.round(c) / 100).toFixed(2).split('.');
    if (!m) return '€' + w + ',' + f;
    return smp.replace(m[0], w.replace(/\B(?=(\d{3})+(?!\d))/g, m[1]) + m[2] + f);
  };
  const countIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      countIO.unobserve(e.target);
      const el = e.target, target = parseFloat(el.dataset.cvCount), mode = el.dataset.cvFormat;
      if (reduce || isNaN(target)) { el.textContent = fmt(target, mode); return; }
      const t0 = performance.now(), dur = 1400;
      const tick = (t) => {
        const p = Math.min(1, (t - t0) / dur), k = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(target * k, mode);
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.4 });
  document.querySelectorAll('[data-cv-count]').forEach((el) => countIO.observe(el));

  /* Kur-Zeitstrahl */
  const kurIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); kurIO.unobserve(e.target); } });
  }, { threshold: 0.35 });
  document.querySelectorAll('[data-cv-kur]').forEach((el) => kurIO.observe(el));

  /* Videos erst laden, wenn sichtbar; pausieren, wenn weg */
  const vidIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) {
        v.querySelectorAll('source[data-src]').forEach((s) => { s.src = s.dataset.src; delete s.dataset.src; });
        if (v.readyState === 0 && v.querySelector('source[src]')) v.load();
        v.play().catch(() => {});
      } else { v.pause(); }
    });
  }, { threshold: 0.2 });
  document.querySelectorAll('video.cv-video').forEach((v) => vidIO.observe(v));

  /* Sanfte Parallaxe */
  if (!reduce) {
    const items = [...document.querySelectorAll('[data-cv-parallax]')];
    if (items.length) {
      let ticking = false;
      const update = () => {
        const vh = window.innerHeight;
        items.forEach((el) => {
          const r = el.getBoundingClientRect();
          const speed = parseFloat(el.dataset.cvParallaxSpeed || '0.12');
          const off = ((r.top + r.height / 2) - vh / 2) * -speed;
          el.style.transform = `translate3d(0, ${off.toFixed(1)}px, 0)`;
        });
        ticking = false;
      };
      window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
      update();
    }
  }

  /* Bento-Zahlen hochzählen: Kacheln mit rein numerischem Großtext */
  document.querySelectorAll('.cl-tile__big').forEach((el) => {
    const raw = el.textContent.trim();
    const m = raw.match(/^([0-9][0-9.,]*)(.*)$/);
    if (!m) return;
    const dm = m[1].match(/[.,](\d{1,2})$/);
    const num = dm ? parseFloat(m[1].slice(0, -dm[0].length).replace(/[.,\s]/g, '') + '.' + dm[1]) : parseFloat(m[1].replace(/[.,\s]/g, ''));
    if (isNaN(num)) return;
    el.dataset.clCount = String(num);
    el.dataset.clSuffix = m[2];
    el.dataset.clDecimals = dm ? dm[1].length : 0;
  });
  const tileIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      tileIO.unobserve(e.target);
      const el = e.target, target = parseFloat(el.dataset.clCount), dec = +el.dataset.clDecimals, suf = el.dataset.clSuffix || '';
      const f = (n) => n.toLocaleString(lang, { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf;
      if (reduce) { el.textContent = f(target); return; }
      const t0 = performance.now(), dur = 1100;
      const tick = (t) => { const p = Math.min(1, (t - t0) / dur), k = 1 - Math.pow(1 - p, 3); el.textContent = f(target * k); if (p < 1) requestAnimationFrame(tick); };
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('.cl-tile__big[data-cl-count]').forEach((el) => tileIO.observe(el));

  /* Hero: Packshot neigt sich zur Maus */
  const heroVisual = document.querySelector('.cl-hero__visual');
  const pack = heroVisual && heroVisual.querySelector('.cl-hero__pack');
  if (pack && !reduce && window.matchMedia('(hover: hover)').matches) {
    heroVisual.addEventListener('mousemove', (ev) => {
      const r = heroVisual.getBoundingClientRect();
      const x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
      heroVisual.classList.add('is-tilting');
      pack.style.transform = `rotateY(${(x * 14).toFixed(1)}deg) rotateX(${(-y * 10).toFixed(1)}deg) translateZ(20px)`;
    });
    heroVisual.addEventListener('mouseleave', () => { heroVisual.classList.remove('is-tilting'); pack.style.transform = ''; });
  }

  /* Sticky-Kaufleiste: sichtbar zwischen Hero-Ende und Packungswahl */
  const sticky = document.querySelector('[data-cl-sticky]');
  const hero = document.querySelector('.cl-hero');
  const packs = document.querySelector('[data-cl-packs]');
  const mainForm = document.querySelector('[id*="__main"] form[data-type="add-to-cart-form"]');
  if (sticky && !hero && mainForm) {
    /* Produktseite: sichtbar, sobald der Kaufen-Button oben aus dem Bild ist; Variante, Preis und Titel folgen dem Hauptformular (das Theme rendert die Spalte bei Variantenwechsel neu) */
    let variants = [];
    try { variants = JSON.parse(sticky.querySelector('[data-cl-sticky-variants]').textContent); } catch (e) {}
    const idIn = sticky.querySelector('[data-cl-sticky-id]'), priceEl = sticky.querySelector('[data-cl-sticky-price]'), subEl = sticky.querySelector('[data-cl-sticky-sub]'), btn = sticky.querySelector('button[type="submit"]');
    let watched = null;
    const set = (on) => { sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); };
    const tick = () => {
      const form = document.querySelector('[id*="__main"] form[data-type="add-to-cart-form"]');
      if (!form) return;
      const mainId = form.querySelector('input[name="id"]');
      const pdp = document.querySelector('[data-cl-pdp]');
      if (pdp) {
        const ap = pdp.querySelector('[data-cl-add-price]'), pk = pdp.querySelector('input[name="cl-pack"]:checked'), bt = pdp.querySelector('input[name="cl-buytype"]:checked');
        if (ap && priceEl) priceEl.textContent = ap.textContent;
        if (subEl && pk) subEl.textContent = pk.closest('label').querySelector('.cl-pk__n').textContent + (bt && bt.value ? ', im Abo' : '');
      } else if (mainId && idIn && idIn.value !== mainId.value) {
        idIn.value = mainId.value;
        const v = variants.find((x) => String(x.id) === mainId.value);
        if (v) { if (priceEl) priceEl.textContent = v.price; if (subEl) subEl.textContent = v.title; if (btn) btn.disabled = !v.available; }
      }
      watched = form.querySelector('.product-form__submit, [name="add"]');
      place();
    };
    /* Scroll-Position statt IntersectionObserver: auf dieser Seite kommen IO-Rückrufe verzögert */
    /* Neue Produktseite: auch zeigen, solange der Button noch unter dem sichtbaren Bereich liegt (Warenkorb immer „above the fold“) */
    const place = () => { if (!watched) return; const r = watched.getBoundingClientRect(); set(r.bottom < 0 || (document.querySelector('[data-cl-pdp]') && r.top > window.innerHeight - 20)); };
    if (btn && document.querySelector('[data-cl-pdp]')) btn.addEventListener('click', (ev) => { ev.preventDefault(); const b = document.querySelector('[data-cl-pdp-add]'); if (b) b.click(); });
    let raf = false;
    window.addEventListener('scroll', () => { if (!raf) { raf = true; requestAnimationFrame(() => { place(); raf = false; }); } }, { passive: true });
    tick(); setInterval(tick, 500);
  }
  if (sticky && hero) {
    let heroGone = false, packsSeen = false;
    const set = () => { const on = heroGone && !packsSeen; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); };
    new IntersectionObserver((es) => { heroGone = !es[0].isIntersecting && es[0].boundingClientRect.bottom < 0; set(); }, { threshold: 0 }).observe(hero);
    if (packs) new IntersectionObserver((es) => { packsSeen = es[0].isIntersecting; set(); }, { threshold: 0.15 }).observe(packs);
  }

  /* Kur-Rechner: heute + 56 Tage */
  document.querySelectorAll('[data-cl-kurrechner]').forEach((box) => {
    const start = new Date(), end = new Date(start.getTime() + 56 * 864e5);
    const fmt = (d) => d.toLocaleDateString(lang, { day: 'numeric', month: 'long' });
    box.querySelector('[data-cl-start]').textContent = fmt(start);
    box.querySelector('[data-cl-end]').textContent = fmt(end);
  });

  /* Warenkorb-Booster: dazulegen oder auf 2er-Variante wechseln. Im Drawer per cart:refresh, auf der Seite per Reload. */
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  const afterCart = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      fetch('/cart.js').then((r) => r.json()).then((c) => { document.querySelectorAll('cart-count, .cart-count-bubble').forEach((el) => { el.textContent = c.item_count; }); }).catch(() => {});
      if (document.body.classList.contains('cart-template')) location.reload();
    } else { location.reload(); }
  };
  document.addEventListener('click', async (ev) => {
    const add = ev.target.closest('[data-cl-add]'), swap = ev.target.closest('[data-cl-swap]');
    if (!add && !swap) return;
    const b = add || swap; b.classList.add('is-busy');
    try {
      if (swap) await post('/cart/change.js', { id: b.dataset.key, quantity: 0 });
      await post('/cart/add.js', { items: [{ id: +b.dataset.variant, quantity: 1 }] });
    } catch (e) {}
    afterCart();
  });

  /* Packungen (hell): Radio → Varianten-ID */
  document.querySelectorAll('[data-cl-packs]').forEach((sec) => {
    const input = sec.querySelector('[data-cl-variant-input]');
    sec.querySelectorAll('input[name="cl-variant"]').forEach((r) => r.addEventListener('change', () => { input.value = r.value; }));
  });

  /* Produkt: Packungswahl → Variante, Preis, Preis je Packung */
  document.querySelectorAll('[data-cv-produkt]').forEach((sec) => {
    const input = sec.querySelector('[data-cv-variant-input]');
    const now = sec.querySelector('[data-cv-price-now]');
    const was = sec.querySelector('[data-cv-price-was]');
    const unit = sec.querySelector('[data-cv-price-unit]');
    const apply = (radio) => {
      if (!radio) return;
      input.value = radio.value;
      now.textContent = money(+radio.dataset.price);
      const cmp = +radio.dataset.compare;
      if (cmp > +radio.dataset.price) { was.textContent = money(cmp); was.hidden = false; } else { was.hidden = true; }
      const n = [...sec.querySelectorAll('input[name="cv-variant"]')].indexOf(radio) + 1;
      unit.textContent = n > 1 ? tr('[a] je Packung', money(+radio.dataset.perPack)) : '';
    };
    sec.querySelectorAll('input[name="cv-variant"]').forEach((r) => r.addEventListener('change', () => apply(r)));
    apply(sec.querySelector('input[name="cv-variant"]:checked'));
  });

  /* Einheitliche Produktseite: Packung, Einmalkauf/Abo, Preise, Galerie */
  document.querySelectorAll('[data-cl-pdp]').forEach((sec) => {
    let data = { variants: [], grams: 0 };
    try { data = JSON.parse(sec.querySelector('[data-cl-pdp-data]').textContent); } catch (e) {}
    const eur = money;
    const $ = (s) => sec.querySelector(s);
    const idIn = $('[data-cl-id]'), qtyIn = $('[data-cl-qty]'), planIn = $('[data-cl-plan]');
    const apply = () => {
      const pk = $('input[name="cl-pack"]:checked'); if (!pk) return;
      const bt = $('input[name="cl-buytype"]:checked');
      const v = data.variants.find((x) => String(x.id) === pk.value) || data.variants[0];
      const qty = +(pk.dataset.qty || 1), n = +(pk.dataset.n || 1), ref = +(pk.dataset.ref || 0);
      const pl = $('input[name="cl-plan"]:checked');
      const plan = bt && bt.value === 'abo' && pl ? pl.value : '';
      const badge = $('[data-cl-abo-badge]'); if (badge && pl && +pl.dataset.pct > 0) badge.textContent = '−' + pl.dataset.pct + ' %';
      const once = v.price * qty;
      const total = plan && v.plans[plan] ? v.plans[plan] * qty : once;
      idIn.value = v.id; qtyIn.value = qty; if (planIn) planIn.value = plan;
      $('[data-cl-now]').textContent = eur(total);
      const was = $('[data-cl-was]'), save = $('[data-cl-save]');
      const showRef = ref > total;
      was.hidden = !showRef; save.hidden = !showRef;
      if (showRef) { was.textContent = eur(ref); save.textContent = tr('Spare [a] %', Math.round((ref - total) / ref * 100)); }
      const unit = $('[data-cl-unit]');
      if (unit && data.grams > 0 && unit.firstChild && unit.firstChild.nodeType === 3) unit.firstChild.textContent = eur(Math.round(total / n / data.grams * 100)) + ' / 100 g';
      const o = $('[data-cl-once]'); if (o) o.textContent = eur(once);
      const ab = $('[data-cl-abo-price]'); if (ab && pl) { const p = v.plans[pl.value]; ab.textContent = p ? eur(p * qty) : ''; }
      const ap = $('[data-cl-add-price]'); if (ap) ap.textContent = eur(total);
      /* Versandhinweis: gratis im Abo oder ab 50 €, sonst kleinste Packungszahl nennen, die gratis wird */
      const sh = $('[data-cl-ship]');
      if (sh) {
        const free = +sh.dataset.free;
        if (plan || total >= free) { sh.textContent = sh.dataset.tOk; sh.classList.add('is-ok'); }
        else {
          let best = 0;
          sec.querySelectorAll('input[name="cl-pack"]').forEach((r) => {
            if (best || r.disabled) return;
            const vv = data.variants.find((x) => String(x.id) === r.value) || data.variants[0];
            if (vv.price * +(r.dataset.qty || 1) >= free) best = +(r.dataset.n || 1);
          });
          sh.textContent = best > 1 ? sh.dataset.tPack.replace('[a]', best) : sh.dataset.tMin;
          sh.classList.remove('is-ok');
        }
        sh.hidden = false;
      }
      const add = $('[data-cl-pdp-add]'); if (add) { add.disabled = !v.available; $('[data-cl-add-label]').textContent = v.available ? (plan ? tr('Abo starten') : tr('In den Warenkorb')) : tr('Ausverkauft'); }
    };
    /* Absenden selbst übernehmen: eine App am Formular verwirft sonst das Abo (selling_plan). Drawer über cart:refresh. */
    const form = sec.querySelector('#cl-pdp-form');
    document.addEventListener('submit', async (ev) => {
      if (ev.target !== form) return;
      ev.preventDefault(); ev.stopImmediatePropagation();
      const btn = $('[data-cl-pdp-add]'); if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
      const item = { id: +idIn.value, quantity: +qtyIn.value || 1 };
      if (planIn && planIn.value) item.selling_plan = +planIn.value;
      try {
        const r = await post('/cart/add.js', { items: [item] });
        if (!r.ok) { const j = await r.json().catch(() => ({})); const err = form.closest('.product-form').querySelector('.product-form__error-message'); if (err) { err.textContent = j.description || tr('Das hat nicht geklappt.'); err.hidden = false; err.parentElement.hidden = false; } }
      } catch (e) {}
      if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); }
      afterCart();
    }, true);
    sec.addEventListener('change', (ev) => { if (ev.target.matches('input[name="cl-plan"]')) { const a = sec.querySelector('input[name="cl-buytype"][value="abo"]'); if (a && !a.checked) a.checked = true; }
      if (ev.target.matches('input[name="cl-pack"], input[name="cl-buytype"], input[name="cl-plan"]')) apply(); });
    apply();
    const track = $('[data-cl-gallery]');
    if (track) {
      const thumbs = [...sec.querySelectorAll('[data-cl-thumb]')], dots = [...sec.querySelectorAll('.cl-pdp__dots i')];
      thumbs.forEach((t) => t.addEventListener('click', () => { const s = track.children[+t.dataset.clThumb]; if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }));
      /* Pfeile (Desktop): ein Bild weiter oder zurück, am Ende wieder vorn */
      sec.querySelectorAll('[data-cl-pfeil]').forEach((b) => b.addEventListener('click', () => {
        const n = track.children.length, i = Math.round(track.scrollLeft / track.clientWidth), z = (i + +b.dataset.clPfeil + n) % n;
        track.scrollTo({ left: track.children[z].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }));
      let r = false;
      track.addEventListener('scroll', () => { if (r) return; r = true; requestAnimationFrame(() => { r = false; const i = Math.round(track.scrollLeft / track.clientWidth); thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i)); dots.forEach((d, k) => d.classList.toggle('is-on', k === i)); }); }, { passive: true });
    }
  });

  /* Kollagen-Vergleich: Balken unter der Wischreihe (Breite = sichtbarer Anteil, Lage per transform) */
  document.querySelectorAll('[data-cl-vgl]').forEach((sec) => {
    const spur = sec.querySelector('[data-cl-vgl-spur]'), bar = sec.querySelector('.cl-vgl__bar span'); if (!spur || !bar) return;
    let raf = 0, cw = 1, breite = window.innerWidth;
    const mass = () => { const sw = spur.scrollWidth; cw = spur.clientWidth || 1; bar.style.setProperty('--d', Math.min(100, cw / sw * 100) + '%'); lage(); };
    const lage = () => { raf = 0; bar.style.transform = 'translateX(' + (spur.scrollLeft / cw * 100) + '%)'; };
    spur.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(lage); }, { passive: true });
    window.addEventListener('resize', () => { if (window.innerWidth === breite) return; breite = window.innerWidth; mass(); });
    mass();
  });

  /* Sortiment-Regal: Packung wählen zeigt die Eckdaten, Filter dimmen, was nicht passt */
  document.querySelectorAll('[data-cl-finder]').forEach((sec) => {
    const items = [...sec.querySelectorAll('.cl-shelf__item')], panels = [...sec.querySelectorAll('.cl-shelf__panel')], tabs = [...sec.querySelectorAll('.cl-shelf__tabs button')];
    const pick = (i) => {
      items.forEach((it) => { const on = it.dataset.i === String(i); it.classList.toggle('is-on', on); it.setAttribute('aria-pressed', on); });
      panels.forEach((p) => { const off = p.dataset.i !== String(i); p.classList.toggle('is-off', off); p.setAttribute('aria-hidden', off); p.querySelectorAll('a').forEach((a) => { a.tabIndex = off ? -1 : 0; }); });
    };
    items.forEach((it) => it.addEventListener('click', () => pick(it.dataset.i)));
    const stg = sec.querySelector('.cl-shelf__stage'), bar = sec.querySelector('.cl-shelf__bar'), thumb = bar && bar.firstElementChild;
    const edge = () => { if (!stg || !bar) return; const sw = stg.scrollWidth, cw = stg.clientWidth; const over = sw > cw + 4;
      thumb.style.width = over ? (cw / sw * 100) + '%' : '100%'; thumb.style.left = over ? (stg.scrollLeft / sw * 100) + '%' : '0%'; };
    if (stg) { stg.addEventListener('scroll', edge, { passive: true }); addEventListener('resize', edge); setTimeout(edge, 300); }
    tabs.forEach((t) => t.addEventListener('click', () => {
      tabs.forEach((x) => x.classList.toggle('is-on', x === t));
      const f = t.dataset.f;
      items.forEach((it) => it.classList.toggle('is-dim', !!f && !it.dataset.tags.split(' ').includes(f)));
      const cur = items.find((it) => it.classList.contains('is-on'));
      if (cur && cur.classList.contains('is-dim')) { const first = items.find((it) => !it.classList.contains('is-dim')); if (first) pick(first.dataset.i); }
      const st = sec.querySelector('.cl-shelf__stage'); if (st) { st.scrollTo({ left: 0, behavior: 'smooth' }); setTimeout(edge, 450); }
    }));
  });

  /* Sets: ein Klick legt alle Teile in den Warenkorb */
  document.addEventListener('click', async (ev) => {
    const b = ev.target.closest('[data-cl-bundle]'); if (!b) return;
    b.classList.add('is-busy'); b.disabled = true;
    const items = b.dataset.clBundle.split(',').map((x) => { const [id, q] = x.split(':'); return { id: +id, quantity: +q }; });
    try { await post('/cart/add.js', { items }); } catch (e) {}
    b.classList.remove('is-busy'); b.disabled = false;
    afterCart();
  });

  /* Warenkorb-Drawer ruhig halten: fremde Upsell-App („Das könnte dir auch gefallen“) im Drawer ausblenden, eigener Booster bleibt */
  const tidyDrawer = () => {
    const d = document.querySelector('cart-drawer'); if (!d) return;
    d.querySelectorAll('cart-items > div, .drawer__body div').forEach((el) => {
      if (el.dataset.clTidy || el.closest('.cl-boost')) return;
      const t = el.firstElementChild && el.innerText || '';
      if (/Das könnte dir auch gefallen/.test(t) && !el.querySelector('.cart-item, [id^="CartDrawer-Item"]')) { el.style.display = 'none'; el.dataset.clTidy = '1'; }
    });
  };
  tidyDrawer();
  const cd = document.querySelector('cart-drawer');
  if (cd) new MutationObserver(tidyDrawer).observe(cd, { childList: true, subtree: true });

  /* Bühne: Video-Loop erst nach dem Laden starten; bei reduzierter Bewegung oder Datensparen bleibt das Foto */
  const sv = document.querySelector('[data-cl-stage-video]');
  if (sv) {
    const calm = matchMedia('(prefers-reduced-motion: reduce)').matches || (navigator.connection && navigator.connection.saveData);
    if (!calm) {
      const go = () => { const so = sv.querySelector('source[data-src]'); if (so) { so.src = so.dataset.src; so.removeAttribute('data-src'); sv.load(); }
        sv.addEventListener('playing', () => sv.classList.add('is-playing'), { once: true }); sv.play().catch(() => {}); };
      go();
    }
  }

  /* Haltungssatz: Wörter färben sich mit dem Scrollen ein */
  document.querySelectorAll('[data-cl-manifest]').forEach((sec) => {
    const ws = [...sec.querySelectorAll('.cl-manifest__w')];
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { ws.forEach((w) => w.classList.add('is-on')); return; }
    let r = false;
    const upd = () => { r = false; const b = sec.getBoundingClientRect(), vh = innerHeight;
      const p = Math.min(1, Math.max(0, (vh * 0.8 - b.top) / (b.height * 0.9 + vh * 0.25)));
      const n = Math.round(p * ws.length); ws.forEach((w, i) => w.classList.toggle('is-on', i < n)); };
    addEventListener('scroll', () => { if (!r) { r = true; requestAnimationFrame(upd); } }, { passive: true });
    upd(); setInterval(upd, 600);
  });

  /* Produktseite: „Offen gelegt“ öffnet Zutaten/Nährwerte; leere Bewertungsbox und fremde Upsell-App ausblenden */
  document.addEventListener('click', (ev) => {
    const a = ev.target.closest('[data-cl-open-acc]'); if (!a) return;
    ev.preventDefault();
    const accs = [...document.querySelectorAll('#cl-pdp-acc .cl-acc')];
    const t = accs.find((d) => /Nährwert/i.test(d.querySelector('summary').textContent)) || accs.find((d) => /Inhaltsstoff/i.test(d.querySelector('summary').textContent)) || accs[0];
    if (t) { t.open = true; t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  });
  if (document.querySelector('[data-cl-pdp]')) {
    const tidyPdp = () => {
      document.querySelectorAll('.shopify-section').forEach((sec) => {
        if (sec.dataset.clTidy) return;
        const t = sec.innerText || '';
        if (/Sei die erste Person|Be the first to write a review/i.test(t) && t.length < 400) { sec.style.display = 'none'; sec.dataset.clTidy = '1'; }
        if (/Wird oft zusammen gekauft|Frequently bought together|Häufig zusammen gekauft/i.test(t) && !sec.querySelector('[data-cl-pdp]')) { sec.style.display = 'none'; sec.dataset.clTidy = '1'; }
      });
    };
    tidyPdp(); let n = 0; const iv = setInterval(() => { tidyPdp(); if (++n > 20) clearInterval(iv); }, 500);
  }
})();
